module.exports = __webpack_public_path__ + "img/aerial-photography-of-rocks-beside-body-of-water.c10a257f.jpg";